import React from 'react'

interface ScrollToVersionItemProps {
  version: string
  slug: string
  isSelected?: boolean
  onClick?: () => void
}

const ScrollToVersionItem: React.FC<ScrollToVersionItemProps> = React.memo(
  ({ version, slug, isSelected = false, onClick }) => {
    const handleClick = (e: React.MouseEvent) => {
      e.preventDefault()
      if (onClick) {
        onClick()
      }
    }

    return (
      <li
        className="changelog-scroll-to-list-item p-2 cursor-pointer flex items-center justify-between"
        style={{
          borderBottom: '1px solid var(--changelog-border)',
          backgroundColor: isSelected
            ? 'var(--changelog-filter-bg)'
            : 'transparent',
        }}
        onMouseEnter={(e) => {
          if (!isSelected) {
            e.currentTarget.style.backgroundColor = 'var(--changelog-filter-bg)'
          }
        }}
        onMouseLeave={(e) => {
          if (!isSelected) {
            e.currentTarget.style.backgroundColor = 'transparent'
          }
        }}
        onClick={handleClick}
      >
        <span
          style={{
            color: isSelected
              ? 'var(--changelog-link-hover)'
              : 'var(--changelog-link)',
            textDecoration: 'none',
            fontWeight: isSelected ? 'bold' : 'normal',
          }}
        >
          {`v${version}`}
        </span>
        {isSelected && (
          <i
            className="fas fa-check text-xs"
            style={{ color: 'var(--changelog-link-hover)' }}
          />
        )}
      </li>
    )
  },
)

export default ScrollToVersionItem
